import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import Navigation from '../navigation/Navigation';

import { TILE_COUNT, checkTile, createTileMessages, getPathData, pathCategories, uncheckTile } from '../../utils/api';

import './Path.css';

function Path({ handleError, handleFeedback }) {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [categoryActive, setCategoryActive] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const getData = useCallback(async () => {
    let categories = pathCategories.map(category => {
      return {
        tiles: [],
        ...category
      };
    });

    try {
      let newTiles = await getPathData();

      if (!newTiles?.length) {
        newTiles = [];
      }
      
      if (newTiles.length < TILE_COUNT) {
        const additionalTiles = await createTileMessages(TILE_COUNT - newTiles.length);

        if (additionalTiles?.length) {
          newTiles = [...newTiles, ...additionalTiles];
        }
      }

      newTiles.forEach(tile => {
        let categoryIndex = categories.findIndex(category => category.name === tile.category);
  
        if (categoryIndex >= 0) {
          categories[categoryIndex].tiles.push(tile);
        }
      });
    } catch (e) {
      handleError(e);
    }

    setCategories(categories);
    setIsLoading(false);
  }, [handleError]);

  const handleClick = useCallback((e, tile) => {
    e.stopPropagation();

    navigate('/guide/path/' + tile._id);
  }, [navigate]);

  const handleTile = useCallback(async (categoryIndex, tileIndex) => {
    try {
      const tile = categories[categoryIndex].tiles[tileIndex];

      if (tile.checkActionId) {
        const response = await uncheckTile(tile.checkActionId);

        if (response) {
          setCategories(prevCategories => {
            prevCategories[categoryIndex].tiles[tileIndex].checkActionId = undefined;
            return [...prevCategories];
          });
        }
      } else {
        const response = await checkTile(tile._id);

        if (response !== null) {
          setCategories(prevCategories => {
            prevCategories[categoryIndex].tiles[tileIndex].checkActionId = response;
            return [...prevCategories];
          });
        }
      }
    } catch (e) {
      handleError(e);
    }
  }, [categories, handleError]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div id="content">
      <div id="path">
        {isLoading ? (
          <div className="loading">Give me a sec...</div>
        ) : (
          <>
            <div className="scrollable">
              <div id="path-container">
                {categories.map((category, ci) => (
                  <React.Fragment key={ci}>
                    <div className="category" onClick={() => setCategoryActive(categoryActive !== ci ? ci : null)}>
                      <div className="icon"><img src={process.env.PUBLIC_URL + '/assets/icons/' + category.name + '.svg'} alt={category.label} /></div>
                      <span>{category.label}</span>
                      <img className="chevron" src={process.env.PUBLIC_URL + '/assets/icons/chevron' + (categoryActive === ci ? '-open' : '') + '.svg'} alt="Open" />
                    </div>
                    <div className="items">
                      {categoryActive === ci ? (
                        category.tiles.map((tile, ti) => (
                          <div key={ti} className="item">
                            <div className="form-check">
                              <input className="form-check-input" type="checkbox" id={'check-' + tile._id} checked={!!tile.checkActionId} onChange={() => handleTile(ci, ti)} />
                              <label className="form-check-label" onClick={(e) => handleClick(e, tile)}>{tile.title}</label>
                            </div>
                            <div className="description" onClick={(e) => handleClick(e, tile)}>{tile.summary}</div>
                          </div>
                        ))
                      ) : null}
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="info">
              <img src={process.env.PUBLIC_URL + '/assets/icons/info.svg'} alt="Info" />
              <span>Tap on each step to see detailed information and tasks</span>
            </div>
          </>
        )}
      </div>
      <Navigation handleFeedback={handleFeedback} />
    </div>
  );
}

export default withAuthenticationRequired(Path);